import(/* webpackMode: "eager", webpackExports: ["SidebarProvider","SidebarContainer"] */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/_common/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/[chainId]/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/stake/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/stake/BarHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/stake/SushiBarProvider.tsx");
